import React, { FC } from 'react';
import type { ExpandedTimeslot } from '../../../utils/expand-timeslots';
import { formatTime, isSlotStartInFuture } from '../../utils/booking-slots';
import type { TimeSegment } from '../../utils/booking-slots';

const SEGMENT_LABELS: Record<TimeSegment, string> = {
  morning: 'Morning',
  afternoon: 'Afternoon',
  evening: 'Evening',
};

interface TimeGridProps {
  /** Mobile: one segment at a time, with segment tabs and the timezone note. */
  compact: boolean
  slots: ExpandedTimeslot[]
  slotsBySegment: Record<TimeSegment, ExpandedTimeslot[]>
  activeSegments: TimeSegment[]
  timeSegment: TimeSegment
  onSelectSegment: (segment: TimeSegment) => void
  selectedDate: string
  selectedSlotStart: string
  onSelectSlot: (slot: ExpandedTimeslot) => void
}

const TimeGrid: FC<TimeGridProps> = ({
  compact,
  slots,
  slotsBySegment,
  activeSegments,
  timeSegment,
  onSelectSegment,
  selectedDate,
  selectedSlotStart,
  onSelectSlot,
}) => (
  <>
    {compact && activeSegments.length > 1 && (
      <div className="flex bg-slate-100 rounded-md p-1 gap-1 mb-3">
        {activeSegments.map((seg) => (
          <button
            key={seg}
            type="button"
            onClick={() => onSelectSegment(seg)}
            className={`flex-1 min-h-seg-btn border-none rounded text-xs font-semibold transition-all ${
              timeSegment === seg
                ? 'bg-white text-brand shadow-sm'
                : 'bg-transparent text-slate-500'
            }`}
          >
            {SEGMENT_LABELS[seg]}
          </button>
        ))}
      </div>
    )}
    <div className={`grid gap-2 ${compact ? 'grid-cols-3' : 'grid-cols-3 md:grid-cols-4'}`}>
      {(compact ? slotsBySegment[timeSegment] : slots).map((slot) => {
        const isSelected = selectedSlotStart === slot.start;
        const isPast = !isSlotStartInFuture(selectedDate, slot.start);
        return (
          <button
            key={slot.start}
            type="button"
            disabled={isPast}
            onClick={() => onSelectSlot(slot)}
            className={`${compact ? 'h-timeslot-btn' : 'py-2.5'} px-3 rounded-xl border-2 text-sm font-semibold transition-all ${
              isPast
                ? 'border-slate-100 bg-slate-50 text-slate-300 cursor-not-allowed'
                : 'cursor-pointer'
            } ${
              !isPast && isSelected
                ? 'border-brand bg-brand text-white'
                : ''
            } ${
              !isPast && !isSelected
                ? 'border-slate-200 bg-white text-slate-600'
                : ''
            }`}
          >
            {formatTime(slot.start)}
          </button>
        );
      })}
    </div>
    {compact && (
      <p className="text-xs text-slate-500 mt-3">
        Times shown in
        {' '}
        <b className="text-slate-700">AEST (Melbourne)</b>
      </p>
    )}
  </>
);

export default TimeGrid;
